export default class CustomTimer {
    #callback;
    #isInterval;
    #isRunning = false;
    #isPaused = false;
    #timerEndTime = 0;
    #initialTimeoutInMs;
    #timeoutInMs;
    #timeoutId = null;
    get remainingTime() {
        if (this.#isPaused) {
            return this.#timeoutInMs;
        }
        return this.#isRunning ? this.#timerEndTime - Date.now() : 0;
    }
    get isRunning() {
        return this.#isRunning;
    }
    get isPaused() {
        return this.#isPaused;
    }
    constructor(callback, timeoutInMs = 0, isInterval = false) {
        this.#callback = callback;
        this.#initialTimeoutInMs = timeoutInMs;
        this.#timeoutInMs = timeoutInMs;
        this.#isInterval = isInterval;
    }
    #onCallback = () => {
        this.clear();
        if (this.#isInterval) {
            this.start();
        }
        this.#callback();
    };
    #setTimer() {
        this.#timeoutId = setTimeout(this.#onCallback, this.#timeoutInMs);
        this.#timerEndTime = Date.now() + this.#timeoutInMs;
    }
    #clearTimer() {
        if (!this.#timeoutId) {
            return;
        }
        clearTimeout(this.#timeoutId);
        this.#timeoutId = null;
        this.#isRunning = false;
    }
    start() {
        if (this.#isRunning) {
            return;
        }
        this.#isRunning = true;
        this.#isPaused = false;
        this.#setTimer();
    }
    pause() {
        if (!this.#isRunning) {
            return;
        }
        this.#timeoutInMs = this.remainingTime;
        this.#isPaused = true;
        this.#clearTimer();
    }
    clear() {
        this.#clearTimer();
        this.#isPaused = false;
        this.#timerEndTime = 0;
        this.#timeoutInMs = this.#initialTimeoutInMs;
    }
}
